import {type IModuloScroll, ModuloScroll} from "../../../root/modulo/scroll";
import {ESelector} from "./auxiliares";
import {ControladorContactWork} from "./ctrl";

export interface IModuloContactWork extends IModuloScroll {
    selector: ESelector;
}

export class ModuloContactWork extends ModuloScroll<IModuloContactWork> {
    /* INSTANCE */
    public constructor(cfg: IModuloContactWork) {
        super({
            margen: "100px",
            visible: 0.0,
            ...cfg,
        });
    }

    protected async controller(element: HTMLElement): Promise<ControladorContactWork> {
        const {ControladorContactWork} = await import(/* webpackChunkName: "module/contact/work/ctrl" */ "./ctrl");

        return new ControladorContactWork({cfg: this.cfg.global, dominio: this.cfg.dominio, element, selector: this.cfg.selector as ESelector});
    }
}
